import Description from "@mui/icons-material/Description";
import RestartAlt from "@mui/icons-material/RestartAlt";
import { Box, Button } from "@mui/material";
import { useGenerateReportMutation } from "app/store/dashboard/surgery_types_procedures/api/surgeryProcedureApi";
import React, { useEffect, useState } from "react";

import { resetProcedureFilters } from "app/store/dashboard/surgery_types_procedures/slice/surgeryProcedureSlice";
import LoadingModal from "components/common/loading/LoadingModal";
import ToastNotification from "components/common/toast/ToastNotification";
import useActiveProcedure from "components/pages/dashboard/surgery_types_procedures/hooks/useActiveProcedure";

const FilterButtons = () => {
  const { activeProcedure, procedureFilters, hasActiveFilters, dispatch } =
    useActiveProcedure();
  const [open, setOpen] = useState(false);
  const [generateReport, { isLoading, isSuccess }] =
    useGenerateReportMutation();

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  useEffect(() => {
    if (isSuccess) {
      setOpen(true);

      setTimeout(() => {
        setOpen(false);
      }, 3000);
    }
  }, [isSuccess]);

  return (
    <>
      {isLoading && (
        <LoadingModal open={isLoading} loadingText="Downloading..." />
      )}
      {isSuccess && (
        <ToastNotification
          open={open}
          onClose={handleClose}
          message="Report downloaded."
        />
      )}
      <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
        <Button
          variant="outlined"
          color="secondary"
          startIcon={<RestartAlt />}
          onClick={() => dispatch(resetProcedureFilters())}
          disabled={!hasActiveFilters}
        >
          Reset Filters
        </Button>
        <Button
          variant="contained"
          color="secondary"
          startIcon={<Description />}
          onClick={() =>
            generateReport({
              procedureId: activeProcedure.id,
              procedureFilters,
            })
          }
          disabled={isLoading}
        >
          Generate Report
        </Button>
      </Box>
    </>
  );
};

export default FilterButtons;
